import * as React from "react";

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 10.99 23.94"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M8.4 0a2.23 2.23 0 012.4 2.34 3.15 3.15 0 01-3.2 3A2.14 2.14 0 015.24 3 3.08 3.08 0 018.4 0zM3.47 23.94c-1.26 0-2.19-.79-1.3-4.22l1.45-6.1c.25-1 .29-1.36 0-1.36a9.41 9.41 0 00-3 1.34L0 12.54c3.07-2.61 6.6-4.15 8.12-4.15 1.26 0 1.47 1.53.84 3.87l-1.66 6.4c-.29 1.13-.17 1.52.13 1.52a6.41 6.41 0 002.84-1.44l.72 1c-2.99 3.02-6.26 4.2-7.52 4.2z" />
    </svg>
  );
}

const MemoSvgInfo = React.memo(SvgInfo);
export default MemoSvgInfo;
